import { render, staticRenderFns } from "./EstudioSis.vue?vue&type=template&id=941de188&"
import script from "./EstudioSis.vue?vue&type=script&lang=js&"
export * from "./EstudioSis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports